module.exports = __webpack_public_path__ + "img/stretch--genre3-img1.d37ef608.jpg";